import Button from "@components/_Revamp/Button";
import HealthMainContainer from "@components/_Revamp/HealthMainContainer";
import InnerContainer from "@components/_Revamp/InnerContainer";
import { css } from "@linaria/core";
import { ROUTE_PATH } from "@static/route-paths";
import { SCREEN_SIZE } from "@static/screen-size";
import React, { useEffect, useMemo, useState } from "react";
import { themeDefault } from "src/theme-revamp";
import Modal from "@components/_Revamp/Modal";
import { Title } from "@components/_Revamp/Typography/Title.stories";
import { useHistory } from "react-router-dom";
import { useAvivaSelector } from "@redux/hook";
import { trackOnCTA, trackOnLoad } from "@pages/CCP/Helpers/analyticsHelper";
import { useScreenSize } from "@pages/CCP/Hooks/useScreenSize";
import { styled } from "@linaria/react";

function Declaration() {
  const history = useHistory();
  const [showModal, setShowModal] = useState(false);
  const backBtnData = useAvivaSelector((state) => state.cancerCoverStep4);

  const random = useMemo(() => {
    return parseInt((Math.random() * 1000000).toString());
  }, []);
  const { isMobile } = useScreenSize();

  useEffect(() => {
    trackOnLoad();
  }, []);
  return (
    <>
      <HealthMainContainer
        className={containerStyle}
        stepList={[]}
        backButtonPath={ROUTE_PATH.CANCER_COVER_MAILING_ADDRESS}
      >
        <section>
          <p>Review documents and declaration</p>
          <p>
            Please ensure that you have clicked on the links and read all
            documents fully before making your declaration.
          </p>
        </section>

        <InnerContainer className="container-1">
          <ul>
            <li>
              I have read and understood the{" "}
              <a
                href={`./ccp/doc/static/${random}/product-summary.pdf`}
                target="_blank"
                rel="noopener noreferrer"
              >
                Product Summary
              </a>{" "}
              including any coverage exclusion stated in the Product Summary.
            </li>
            <li>
              I have downloaded, fully read and understood the{" "}
              <a
                href={`./ccp/doc/static/${random}/policy-terms-conditions.pdf`}
                target="_blank"
                rel="noopener noreferrer"
              >
                Policy Terms & Conditions.
              </a>
            </li>
            <li>
              I have read and agreed to the statements described in the{" "}
              <a
                href={`./ccp/doc/static/${random}/declarations-document.pdf`}
                target="_blank"
                rel="noopener noreferrer"
              >
                Declaration Document.
              </a>
            </li>
            <li>
              I have completed and disclosed fully and truthfully all the
              information requested for in this application.
            </li>
            <li>
              I understand that any misrepresentation or concealment of facts
              shall render the policy to be issued and any other policy which I
              have with Singlife to which the information applies null and void.
            </li>
            <li>
              I am purchasing this plan without any advice from a Financial
              Adviser Representative and I take responsibility to ensure that
              this plan suits my needs.
            </li>
            <li>
              I understand that I may refer to the{" "}
              <a
                href="https://www.lia.org.sg/tools-and-resources/insurance-calculator-intro/"
                target="_blank"
                rel="noopener noreferrer"
              >
                LIA Calculator
              </a>{" "}
              to work out my approximate protection needs and gaps, and the{" "}
              <a
                href="https://www.moneysense.gov.sg/planning-your-finances-well/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Basic Financial Planning Guide
              </a>{" "}
              to identify and address gaps in my finances.
            </li>
            <li>
              <p>
                If I decide to switch from/replace my existing policy, I
                understand that:
              </p>
              <ol>
                <li>
                  (a) I may incur transaction costs without gaining any real
                  benefit from the switch/replacement.
                </li>
                <li>
                  (b) I may incur penalties for terminating the existing
                  policies.
                </li>
                <li>(c) I may not be insurable at standard terms.</li>
                <li>
                  (d) The switch/replacement policy may offer a lower level of
                  benefit at a higher cost or same cost, or offer the same level
                  of benefit at a higher cost.
                </li>
                <li>
                  (e) The switch/replacement policy may be less suitable and the
                  terms and conditions may differ.
                </li>
                <li>
                  (f) There may be other options available besides
                  switching/replacing the policy.
                </li>
              </ol>
            </li>
            <li>
              I understand that I will receive my policy, any endorsements and
              communications electronically once they are ready. I understand
              that I may log on to MySinglife to opt for my preferred document
              option and may switch between e-documents and printed documents.
            </li>
          </ul>
        </InnerContainer>
        <div className="btnContainer">
          <Button
            label={"I do not agree"}
            hoverBgColor={themeDefault.colors.white}
            bgColor={themeDefault.colors.white}
            textColor={themeDefault.colors.primary}
            hoverTextColor={themeDefault.colors.primary}
            onClick={() => {
              trackOnCTA({
                ctaText: "I do not agree",
                ctaType: "qb:link",
              });
              setShowModal(true);
            }}
          />
          <Button
            label={"Agree to all"}
            hoverBgColor={themeDefault.colors.primary}
            onClick={() => {
              trackOnCTA({
                ctaText: "Agree to all",
                ctaType: "qb:link",
              });
              history.push(ROUTE_PATH.CANCER_COVER_FINANCIAL_ADVISER);
            }}
          />
        </div>
      </HealthMainContainer>
      {showModal && (
        <Modal
          show={showModal}
          className={modalStyle}
          colseBtnColor="#883E89"
          onClose={() => {
            setShowModal(false);
          }}
        >
          <Header marginTop={"0"}>Need help with your declaration?</Header>
          <p>
            Contact us if you have any concerns or need help with any part of
            the declaration.
          </p>
          <div className="modalContainer">
            <Button
              label={"Back to Home"}
              hoverBgColor={themeDefault.colors.white}
              bgColor={themeDefault.colors.white}
              textColor={themeDefault.colors.primary}
              hoverTextColor={themeDefault.colors.primary}
              onClick={() => {
                window.location.href = "https://singlife.com";
              }}
            />
            <Button
              disabled={false}
              label={"Contact us"}
              onClick={() => {
                history.push(ROUTE_PATH.CANCER_COVER_CONTACT_US);
              }}
            />
          </div>
        </Modal>
      )}
    </>
  );
}

export default Declaration;

const containerStyle = css`
  display: flex;
  flex-direction: column;
  gap: 24px;
  font-size: 14px;
  color: #434343;
  a {
    color: #883E89;
    font-weight: 600;
  }
  & > section {
    display: flex;
    font-size: 28px;
    font-weight: 600;
    line-height: 39.2px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 16px;
    margin-top: -24px;
    p:first-child {
      letter-spacing: 0.42px;
      font-size: 18px;
    }
    p:nth-child(2) {
      font-size: 14px;
      line-height: 22.4px;
      max-width: 362px;
      text-align: center;
      color: #8a8988;
    }
  }

  .container-1 {
    ul {
      padding: 24px;
      display: flex;
      flex-direction: column;
      gap: 24px;

      ol {
        list-style: none;
        max-width: 650px;
        margin-top: 8px;
      }
    }
  }

  .btnContainer {
    display: flex;
    flex-direction: column;
    box-shadow: none;
    gap: 8px;
    button {
      box-shadow: none;
    }
  }
  @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    & > section {
      margin-top: unset;

      p:first-child {
        font-size: unset;
      }
    }
    .container-1 {
      ul {
        ol {
          padding-left: 30px;
          margin-top: unset;
        }
      }
    }
    .btnContainer {
      flex-direction: row;
      justify-content: center;
      align-items: center;
      box-shadow: none;
      width: 100%;
      button {
        max-width: 184px;
      }
    }
  }
`;

const modalStyle = css`
  .modal-body {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 24px;
    & > div {
      width: 100%;
    }
    @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
      gap: 16px;
    }
  }
  p:nth-child(2) {
    color: #8a8988;
    font-size: 14px;
    font-weight: 600;
    text-align: center;
    line-height: 19.6px;
    margin-bottom: 0px;
    @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
      margin-bottom: 48px;
    }
  }

  button {
    width: 100%;
    font-weight: 600;
    font-size: 14px;
    letter-spacing: 1.28px;
    box-shadow: none;
    line-height: 22.4px;
    @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
      font-size: 16px;
    }
  }
  .modalContainer {
    display: flex;
    flex-direction: column;
    gap: 8px;
    button {
      box-shadow: none;
    }
  }
  @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    .modal-body {
      & > div {
        width: 100%;
      }
    }
    button {
      max-width: 180px;
    }
    .modalContainer {
      flex-direction: row;
      justify-content: center;
      gap: 24px;
    }
  }
`;

export const Header = styled.div<{ marginTop?: string }>`
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 600;
  line-height: 140%;
  text-align: center;
  color: #434343;
  font-size: 18px;
  margin: 0 auto 0 auto;
  @media (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    font-size: 28px;
    margin-top: ${(prop) => prop.marginTop || "24"}px;
    margin: 0 auto 24px auto;
  }
`;
